import { getLocaleConfig as getState } from "modules/root/root-selectors";
import { createSelector } from "reselect";

export const getLocaleConfig = getState;

export const getLocale = createSelector(
  getState,
  localeConfig => localeConfig.locale
);



// WEBPACK FOOTER //
// ./src/modules/i18n/locale-selectors.js